<div class="wrapper" @height>
  <div class="header">
    <h2>{{ 'notifications' | translate }}</h2>
    @if (newsNotifications?.newsNotifications) {
      <div class="notification-number">
        {{ newsNotifications.newsNotifications.length }}
      </div>
    }
  </div>

  <div class='container'>
    @for (news of newsNotifications?.newsNotifications; track news) {
      <gl-news-item
        [news]="news"
        (dismiss)="getNotifications()"
      ></gl-news-item>
    }
  </div>
</div>
